import HondaBeatImg from "@/assets/images/landing_page/img-honda-beat.png";
import HondaVarioImg from "@/assets/images/landing_page/img-honda-vario.png";
import HondaSupraGtrImg from "@/assets/images/landing_page/img-honda-supra-gtr.png";
import YamahaMioImg from "@/assets/images/landing_page/img-yamaha-mio.png";
import YamahVixionImg from "@/assets/images/landing_page/img-yamaha-vixion.png";
import YamahaMxKingImg from "@/assets/images/landing_page/img-yamaha-mx-king.png";
import VespaPiaggioImg from "@/assets/images/landing_page/img-vespa-piaggio.png";
import VespaSprintPng from "@/assets/images/landing_page/img-vespa-sprint.png";

export const efundingLendingProducts = [
  {
    id: 1,
    installments: "Rp 502.000",
    down_payment: "Rp 2.250.000",
    price: "Rp 14.775.000",
    imageSrc: HondaBeatImg,
  },
  {
    id: 2,
    installments: "Rp 502.000",
    down_payment: "Rp 2.250.000",
    price: "Rp 14.775.000",
    imageSrc: HondaVarioImg,
  },
  {
    id: 3,
    installments: "Rp 502.000",
    down_payment: "Rp 2.250.000",
    price: "Rp 14.775.000",
    imageSrc: HondaSupraGtrImg,
  },
  {
    id: 4,
    installments: "Rp 502.000",
    down_payment: "Rp 2.250.000",
    price: "Rp 14.775.000",
    imageSrc: YamahaMioImg,
  },
  {
    id: 5,
    installments: "Rp 502.000",
    down_payment: "Rp 2.250.000",
    price: "Rp 14.775.000",
    imageSrc: YamahVixionImg,
  },
  {
    id: 6,
    installments: "Rp 502.000",
    down_payment: "Rp 2.250.000",
    price: "Rp 14.775.000",
    imageSrc: YamahaMxKingImg,
  },
  {
    id: 7,
    installments: "Rp 502.000",
    down_payment: "Rp 2.250.000",
    price: "Rp 14.775.000",
    imageSrc: VespaPiaggioImg,
  },
  {
    id: 8,
    installments: "Rp 502.000",
    down_payment: "Rp 2.250.000",
    price: "Rp 14.775.000",
    imageSrc: VespaSprintPng,
  },
];



// WEBPACK FOOTER //
// ./src/utils/efunding_lending_products.js